import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { ControlActions, ControllerMethods, TipoObjetoParaPermisos } from 'src/app/models/general.enum';
import { Enumerable, List } from 'linqts';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ConfigWindow } from 'src/app/models/config-window';
import { CrudActions } from '../../../models/general.enum';
import { DataTableComponent } from 'src/app/components/controls/data-table/data-table.component';
import { GeneralFormComponent } from 'src/app/components/controls/general-form/general-form.component';
import { Guid } from "guid-typescript";
import { StaticData } from '../../../helpers/static-data';
import { utils } from 'protractor';

@Component({
  selector: 'app-external-pqrs',
  templateUrl: './external-pqrs.component.html',
  styleUrls: ['./external-pqrs.component.scss']
})
export class ExternalPqrsComponent extends GeneralFormComponent implements OnInit {

  NoDatos: any;
  NoDato: any;
  Genero: any;
  Indicativo: any;
  PrimerNombre: any;
  SegundoNombre: any;
  PrimerApellido: any;
  SegundoApellido: any;
  RazonSocial: any;
  Cargo: any;
  TipoContacto: any;
  TipoIdentificacion: any;
  NumeroIdentificacion: any;
  Pais: any;
  Departamento: any;
  Ciudad: any;
  Direccion: any;
  CodigoPostal: any;
  Celular: any;
  Telefono: any;
  Extension: any;
  Correo: any;
  CorreoConfirm: any;
  IdTipoRespuesta: any;
  IdTipoRespuestaAutenticado: any;
  /*IdCausalRechazo: any;*/
  CheckSolicitudAnonima: any;
  AccordionGeneral: any;
  MensajeContacto: any;
  MensajeContactoAnonimo: any;
  //AccordionPoliticas: any;
  TextoNotificacionElectronica: any;
  TextoTratamientoDatos: any;
  MensajeConfirmar: any;
  AceptaPublicarRespuesta: any;
  AceptaTratamientoDatos: any;
  AceptaTerminos: any;
  UserData: any;
  Anonimo: any = false;
  Radicado: any;
  SolicitudAnonimaHeader: any;
  MensajeSolicitudAnonima: any;
  CorreoEmail: any;
  cnfgButtons: any;
  DatosUsuario: any;
  DatosIngreso: any;
  Meses: any = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Dicembre"];
  recaptchaReactive: FormControl;
  ctrAceptaPublicarRespuesta: any;
  ctrAceptaTratamientoDatos: any;
  ctrAceptaTerminos: any;
  Logged: any = false;
  model: any = { UData: 'marlong@bextsa.com', CData: '', TipoSistema: null, AppKey: null };

  /*ngOnInit() {
    //debugger;
    if (StaticData.Usuario == null || StaticData.Usuario == undefined) {
      this.LoginPqr();
    }

    super.ngOnInit();
  }*/

  ngAfterViewInit() {
    this.ctrAceptaPublicarRespuesta = this.form.controls["AceptaPublicarRespuesta"];
    this.ctrAceptaTratamientoDatos = this.form.controls["AceptaTratamientoDatos"];
    this.ctrAceptaTerminos = this.form.controls["AceptaTerminos"];
    this.CheckSolicitudAnonima = this.form.controls["CheckSolicitudAnonima"];
    this.NoDato = this.form.controls["NoDato"];

    /*if (this.CheckSolicitudAnonima) {
      //debugger;
      this.CheckSolicitudAnonima.valueChanges.subscribe(value => {
        //debugger;
        if (value != null) {
          if (value) {
            const context = this;
            const action = {
              ControlDetails: {
                MappingData: [],
                MappingFilter: []
              },
              ControlType: "Action",
              ControlsForHidden: [],
              //ControlsToUpdate: ["IdGenero", "PrimerNombre", "PrimerApellido", "RazonSocial", "Cargo", "IdDatoBasico", "TipoIdentificacion", "Identificacion", "IdPais", "IdDepartamento", "IdCiudad", "Direccion", "Celular", "Correo", "CorreoConfirm", "AceptaTratamientoDatos", "AceptaTerminos"],
              ControlsToUpdate: ["IdGenero", "PrimerNombre", "PrimerApellido", "RazonSocial", "Cargo", "IdDatoBasico", "TipoIdentificacion", "Identificacion", "IdPais", "IdDepartamento", "IdCiudad", "Direccion", "Celular", "Correo", "CorreoConfirm"],
              Guid: Guid.create().toString(),
              IsPost: false,
              IsParentModel: false,
              MappingValues: [],
              MappingComponents: [],
              Property: "required",
              PropertyValue: "false",
              ResultType: "Url",
              SendQueryString: false,
              TimerAction: 0,
              Type: ControlActions[ControlActions.SetControlProperty]
            };
            this.helperActions.SetControlsValue(action, context);

            const actionRS = {
              ControlDetails: {
                MappingData: [],
                MappingFilter: []
              },
              ControlType: "Action",
              ControlsForHidden: [],
              ControlsToUpdate: ["AceptaPublicarRespuesta"],
              Guid: Guid.create().toString(),
              IsPost: false,
              IsParentModel: false,
              MappingValues: [],
              MappingComponents: [],
              Property: "required",
              PropertyValue: "true",
              ResultType: "Url",
              SendQueryString: false,
              TimerAction: 0,
              Type: ControlActions[ControlActions.SetControlProperty]
            };
            this.helperActions.SetControlsValue(actionRS, context);

            this.LimpiarDatosContacto();
            this.NoDatos.Hidden = false;
            this.AccordionGeneral.Hidden = false;
            this.MensajeContacto.Hidden = false;
            this.Genero.Hidden = true;
            this.PrimerNombre.Hidden = true;
            this.SegundoNombre.Hidden = true;
            this.PrimerApellido.Hidden = true;
            this.SegundoApellido.Hidden = true;
            this.RazonSocial.Hidden = true;
            this.Cargo.Hidden = true;
            this.SolicitudAnonimaHeader.Hidden = false;
            this.MensajeSolicitudAnonima.Hidden = false;
            this.Pagina.Titulo = 'Formular una solicitud anónima';
            //this.AccordionPoliticas.Hidden = true;
            this.TextoNotificacionElectronica.Hidden = false;
            this.TextoTratamientoDatos.Hidden = false;
            this.TipoPersona.Hidden = true;
            this.TipoIdentificacion.Hidden = true;
            this.NumeroIdentificacion.Hidden = true;
            this.Pais.Hidden = true;
            this.Departamento.Hidden = true;
            this.Ciudad.Hidden = true;
            this.Indicativo.Hidden = true;
            this.Direccion.Hidden = true;
            this.CodigoPostal.Hidden = true;
            this.Celular.Hidden = true;
            this.Telefono.Hidden = true;
            this.Extension.Hidden = true;
            this.Correo.Hidden = true;
            this.CorreoConfirm.Hidden = true;
            this.modelo.modelo.EsAnonima = true;
            this.AceptaPublicarRespuesta.Hidden = false;
            this.AceptaTratamientoDatos.Hidden = false;
            this.modelo.modelo.NoDatosPersonales = false;
            this.AceptaTerminos.Hidden = false;
            this.modelo.modelo.IdTipoSolicitud = '';
            this.modelo.modelo.IdTemaSolicitud = '';
            this.SetModelToControls();
            $("input[id='NoDato']").prop('checked', false);
            $("input[id='CheckSolicitudAnonima']").prop('checked', true);
          }
          else {
            const context = this;
            const action = {
              ControlDetails: {
                MappingData: [],
                MappingFilter: []
              },
              ControlType: "Action",
              ControlsForHidden: [],
              ControlsToUpdate: ["IdGenero", "PrimerNombre", "PrimerApellido", "RazonSocial", "Cargo", "IdDatoBasico", "TipoIdentificacion", "Identificacion", "IdPais", "IdDepartamento", "IdCiudad", "Direccion", "Celular", "Correo", "CorreoConfirm", "AceptaTratamientoDatos", "AceptaTerminos", "AceptaPublicarRespuesta"],
              Guid: Guid.create().toString(),
              IsPost: false,
              IsParentModel: false,
              MappingValues: [],
              MappingComponents: [],
              Property: "required",
              PropertyValue: "true",
              ResultType: "Url",
              SendQueryString: false,
              TimerAction: 0,
              Type: ControlActions[ControlActions.SetControlProperty]
            };
            this.helperActions.SetControlsValue(action, context);

            // const actionRS = {
            //   ControlDetails: {
            //     MappingData: [],
            //     MappingFilter: []
            //   },
            //   ControlType: "Action",
            //   ControlsForHidden: [],
            //   ControlsToUpdate: ["RazonSocial", "Cargo"],
            //   Guid: Guid.create().toString(),
            //   IsPost: false,
            //   IsParentModel: false,
            //   MappingValues: [],
            //   MappingComponents: [],
            //   Property: "required",
            //   PropertyValue: "false",
            //   ResultType: "Url",
            //   SendQueryString: false,
            //   TimerAction: 0,
            //   Type: ControlActions[ControlActions.SetControlProperty]
            // };
            // this.helperActions.SetControlsValue(actionRS, context);

            this.NoDatos.Hidden = true;
            this.Genero.Hidden = false;
            this.AccordionGeneral.Hidden = false;
            this.MensajeContacto.Hidden = false;
            this.AceptaPublicarRespuesta.Hidden = false;
            this.PrimerNombre.Hidden = false;
            this.SegundoNombre.Hidden = false;
            this.PrimerApellido.Hidden = false;
            this.SegundoApellido.Hidden = false;
            this.RazonSocial.Hidden = true;
            this.Cargo.Hidden = true;
            this.SolicitudAnonimaHeader.Hidden = true;
            this.MensajeSolicitudAnonima.Hidden = true;
            this.Pagina.Titulo = 'Formular una solicitud';
            //this.AccordionPoliticas.Hidden = false;
            this.TextoNotificacionElectronica.Hidden = false;
            this.AceptaTratamientoDatos.Hidden = false;
            this.TextoTratamientoDatos.Hidden = false;
            this.MensajeConfirmar.Hidden = false;
            this.TipoPersona.Hidden = false;
            this.TipoIdentificacion.Hidden = false;
            this.NumeroIdentificacion.Hidden = false;
            this.Pais.Hidden = false;
            this.Departamento.Hidden = false;
            this.Ciudad.Hidden = false;
            this.Indicativo.Hidden = false;
            this.Direccion.Hidden = false;
            this.CodigoPostal.Hidden = false;
            this.Celular.Hidden = false;
            this.Telefono.Hidden = false;
            this.Extension.Hidden = false;
            this.Correo.Hidden = false;
            this.CorreoConfirm.Hidden = false;
            this.modelo.modelo.EsAnonima = false;
            this.AceptaTerminos.Hidden = false;
            this.modelo.modelo.IdTipoSolicitud = '';
            this.modelo.modelo.IdTemaSolicitud = '';
            this.SetModelToControls();
            $("input[id='CheckSolicitudAnonima']").prop('checked', false);
          }
        }
        else {
          $("input[id='NoDato']").prop('checked', this.modelo.modelo.NoDatosPersonales);
          $("input[id='CheckSolicitudAnonima']").prop('checked', this.modelo.modelo.EsAnonima);
        }
      });
    }*/

    if (this.NoDato) {
      //debugger;
      this.NoDato.valueChanges.subscribe(value => {
        //debugger;
        if (value != null) {
          if (value == true) {

            const context = this;
            const action = {
              ControlDetails: {
                MappingData: [],
                MappingFilter: []
              },
              ControlType: "Action",
              ControlsForHidden: [],
              ControlsToUpdate: ["IdTipoRespuesta", "Correo", "CorreoConfirm", "Celular",  "AceptaPublicarRespuesta", "AceptaTratamientoDatos", "IdPais", "IdDepartamento", "IdCiudad", "Direccion"],
              Guid: Guid.create().toString(),
              IsPost: false,
              IsParentModel: false,
              MappingValues: [],
              MappingComponents: [],
              Property: "required",
              PropertyValue: "false",
              ResultType: "Url",
              SendQueryString: false,
              TimerAction: 0,
              Type: ControlActions[ControlActions.SetControlProperty]
            };
            this.helperActions.SetControlsValue(action, context);

            this.LimpiarDatosContacto();
            this.AceptaPublicarRespuesta.Hidden = true;
            this.TextoNotificacionElectronica.Hidden = true;
            this.AceptaTratamientoDatos.Hidden = true;
            this.TextoTratamientoDatos.Hidden = true;
            this.MensajeConfirmar.Hidden = true;
            this.modelo.modelo.NoDatosPersonales = true;
            this.modelo.modelo.IdTipoRespuesta = 36;
            this.AccordionGeneral.Hidden = true;
            this.MensajeContactoAnonimo.Hidden = true;
            this.SetModelToControls();
            $("input[id='NoDato']").prop('checked', true);


          }
          else {

            const context = this;
            const action = {
              ControlDetails: {
                MappingData: [],
                MappingFilter: []
              },
              ControlType: "Action",
              ControlsForHidden: [],
              ControlsToUpdate: ["IdTipoRespuesta", "AceptaPublicarRespuesta", "AceptaTratamientoDatos","Correo", "CorreoConfirm"],
              Guid: Guid.create().toString(),
              IsPost: false,
              IsParentModel: false,
              MappingValues: [],
              MappingComponents: [],
              Property: "required",
              PropertyValue: "true",
              ResultType: "Url",
              SendQueryString: false,
              TimerAction: 0,
              Type: ControlActions[ControlActions.SetControlProperty]
            };
            this.helperActions.SetControlsValue(action, context);
            this.Pais.Hidden = true;
            this.Departamento.Hidden = true;
            this.Ciudad.Hidden = true;
            this.Direccion.Hidden = true;
            this.CodigoPostal.Hidden = true;
            this.Correo.Hidden = false;
            this.CorreoConfirm.Hidden = false;
            this.AceptaPublicarRespuesta.Hidden = false;
            this.TextoNotificacionElectronica.Hidden = false;
            this.AceptaTratamientoDatos.Hidden = false;
            this.TextoTratamientoDatos.Hidden = false;
            this.MensajeConfirmar.Hidden = false;
            this.modelo.modelo.NoDatosPersonales = false;
            this.AccordionGeneral.Hidden = false;
            this.MensajeContactoAnonimo.Hidden = false;
            this.SetModelToControls();
            $("input[id='NoDato']").prop('checked', false);
          }
        }
        else {
          $("input[id='NoDato']").prop('checked', this.modelo.modelo.NoDatosPersonales);
        }
      });

    }

    if (this.ctrAceptaPublicarRespuesta) {
      //debugger;
      this.ctrAceptaPublicarRespuesta.valueChanges.subscribe(value => {
        //debugger;
        if (value == false) {
          this.ctrAceptaPublicarRespuesta.value = null;
          this.ctrAceptaPublicarRespuesta.pristine = true;
          this.ctrAceptaPublicarRespuesta.errors = { required: true };
          this.ctrAceptaPublicarRespuesta.status = "INVALID";
        }
      });
    }

    if (this.ctrAceptaTratamientoDatos) {
      //debugger;
      this.ctrAceptaTratamientoDatos.valueChanges.subscribe(value => {
        //debugger;
        if (value == false) {
          this.ctrAceptaTratamientoDatos.value = null;
          this.ctrAceptaTratamientoDatos.pristine = true;
          this.ctrAceptaTratamientoDatos.errors = { required: true };
          this.ctrAceptaTratamientoDatos.status = "INVALID";
        }

      });
    }

    if (this.ctrAceptaTerminos) {
      //debugger;
      this.ctrAceptaTerminos.valueChanges.subscribe(value => {
        //debugger;
        if (value == false) {
          this.ctrAceptaTerminos.value = null;
          this.ctrAceptaTerminos.pristine = true;
          this.ctrAceptaTerminos.errors = { required: true };
          this.ctrAceptaTerminos.status = "INVALID";
        }

      });
    }

    super.ngAfterViewInit();
  }

  public LimpiarDatosContacto() {
    this.modelo.modelo.IdTipoRespuesta = null;
    this.modelo.modeloCascada.IdDatoBasico = null;
    this.modelo.modeloCascada.TipoIdentificacion = null;
    this.modelo.modelo.Identificacion = null;
    this.modelo.modelo.RazonSocial = null;
    this.modelo.modelo.Cargo = null;
    this.modelo.modelo.IdGenero = null;
    this.modelo.modelo.PrimerNombre = null;
    this.modelo.modelo.SegundoNombre = null;
    this.modelo.modelo.PrimerApellido = null;
    this.modelo.modelo.SegundoApellido = null;
    this.modelo.modeloCascada.IdPais = null;
    this.modelo.modeloCascada.IdDepartamento = null;
    this.modelo.modeloCascada.IdCiudad = null;
    this.modelo.modelo.Direccion = null;
    this.modelo.modelo.CodigoPostal = null;
    this.modelo.modelo.Celular = null;
    this.modelo.modelo.Telefono = null;
    this.modelo.modelo.Ext = null;
    this.modelo.modelo.Correo = null;
    this.modelo.modelo.CorreoConfirm = null;
    this.modelo.modelo.Indicativo = null;
    this.modelo.modeloVirtual.IdTipoRespuestaAutenticado = null;
    this.SetModelToControls();
  }

  public PostNgAfterViewInit() {

    /**/

    /*control.valueChanges.subscribe(x => {
      this.modelo.modelo.Captcha = x;
    }); */

    /*if (this.UserData != null && this.UserData != undefined) {
      //debugger;
      this.SetCascading();
    }*/

    this.postSaveEmitter.subscribe(modelo => {
      //debugger;


      /*if (!this.Anonimo) {
      //let obj = this.utility.GetApiModel('GetExternalPQRDocumentExport', null);
      this.modelo.modelo.DataAdd = {
        IdSolicitudPqrd: modelo.data.data.IdSolicitudPqrd,
        NombresApellidos: this.UserData.PrimerNombre + ' ' + (this.UserData.SegundoNombre != null && this.UserData.SegundoNombre != undefined ? this.UserData.SegundoNombre + ' ' : '') + this.UserData.PrimerApellido + ' ' + this.UserData.SegundoApellido,
        NumeroRadicado: modelo.data.data.Codigo,
        CorreoContacto: this.CorreoEmail,
        Empresa: this.UserData.Empresa,
        Contacto: this.UserData.IdContacto,
        Celular: this.modelo.modelo.Celular,
        Telefono: this.modelo.modelo.Telefono,
        Ext: this.modelo.modelo.Ext,
        Ciudad: this.modelo.modeloCascada.IdCiudad,
        Direccion: this.modelo.modelo.Direccion,
        Correo: this.modelo.modelo.Correo
      }
      //obj.modelo = this.modelo.modelo;
      if (this.cnfgButtons && this.cnfgButtons.Actions) {
  
        this.helperActions.ExecuteActionsControl(this.cnfgButtons,
          false, null, this.modelo, this.permissionsConfig,
          this, null, new EventEmitter<any>(), this.componentsContainer,
          null, this.modelo.modeloMetadata, { importUrl: this.importUrl });
      }*/

      /*var obj = this.utility.GetApiModel('InsertDatosPersonalesSolicitudPqrd', this.componentName);
  
        obj.QueryConfig.Command = 'InsertDatosPersonalesSolicitudPqrd';
        obj.QueryConfig.IsSp = true;
        //debugger;
        obj.QueryConfig.Entity = { 
          IdSolicitudPqrd: modelo.data.data.IdSolicitudPqrd,
          IdTipoContacto: modelo.modelo.modelo.IdTipoContacto,
          IdTipoIdentificacion: modelo.modelo.modelo.TipoIdentificacion,
          Identificacion: modelo.modelo.modelo.Identificacion,
          PrimerNombre: modelo.modelo.modelo.PrimerNombre,
          SegundoNombre: modelo.modelo.modelo.SegundoNombre,
          PrimerApellido: modelo.modelo.modelo.PrimerApellido,
          SegundoApellido: modelo.modelo.modelo.SegundoApellido,
          RazonSocial: modelo.modelo.modelo.RazonSocial,
          Cargo: ''
        };
        // obj.QueryConfig.Entity = (esEdicion) ? { IdTablaRetencionDocumental: this.modelo.modelo.IdTablaRetencionDocumental } : this.modelo.modeloCascada;
        // this.baseService.showLoadNotifyType =true;
        this.baseService.Get(obj, null,
          {
            componentName: this.componentName,
            method: 'InsertDatosPersonalesSolicitudPqrd',
            processMessage: 'Procesando...'
          }, 'TSolicitudPqrd')
          .then(data => {
            //debugger;
            var a = JSON.stringify(data.Data[0]);
  
          }).catch(err => {
            //debugger;
            this.utility.logger.LogError(err, obj, {
              componentName: this.componentName,
              method: 'InsertDatosPersonalesSolicitudPqrd',
              processMessage: 'Procesando...'
            }, 'TSolicitudPqrd')
          });*/

      this.utility.VerModalOk("Se creó la PQRS con el siguiente Código, favor tome nota para próximas consultas " + "\n\r" + modelo.data.data.Codigo).then(modelo => {
        if (modelo.dialogResult == true) {
          $('.ms-Overlay.is-visible').remove();
          //location.reload();
          var CurrentUrl = window.location.href;
          window.location.href = CurrentUrl.replace('ExternalPQR', 'HomeExternalPQR');

        }
      });

    });





    //});
  }


  public OnInitEnd() {
    //debugger;
    this.CheckSolicitudAnonima = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "CheckSolicitudAnonima" });
    this.NoDatos = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "NoDato" });
    this.AccordionGeneral = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "AccordionGeneral" });
    this.MensajeContacto = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "MensajeContacto" });
    this.MensajeContactoAnonimo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "MensajeContactoAnonimo" });
    //this.AccordionPoliticas = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "AccordionPoliticas" });
    this.TextoNotificacionElectronica = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "TextoNotificacionElectronica" });
    this.TextoTratamientoDatos = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "TextoTratamientoDatos" });
    this.SolicitudAnonimaHeader = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "SolicitudAnonimaHeader" });
    this.MensajeSolicitudAnonima = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "MensajeSolicitudAnonima" });
    this.Genero = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdGenero" });
    this.PrimerNombre = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "PrimerNombre" });
    this.SegundoNombre = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "SegundoNombre" });
    this.PrimerApellido = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "PrimerApellido" });
    this.SegundoApellido = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "SegundoApellido" });
    this.RazonSocial = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "RazonSocial" });
    this.Cargo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Cargo" });
    this.TipoContacto = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdTipoContacto" });
    this.IdTipoRespuesta = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdTipoRespuesta" });
    this.IdTipoRespuestaAutenticado = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdTipoRespuestaAutenticado" });
    this.TipoIdentificacion = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdTipoIdentificacion" });
    this.NumeroIdentificacion = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Identificacion" });
    this.Pais = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdPais" });
    this.Departamento = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdDepartamento" });
    this.Ciudad = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdCiudad" });
    this.Indicativo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Indicativo" });
    this.Direccion = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Direccion" });
    this.CodigoPostal = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "CodigoPostal" });
    this.Celular = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Celular" });
    this.Telefono = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Telefono" });
    this.Extension = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Ext" });
    this.Correo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Correo" });
    this.CorreoConfirm = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "CorreoConfirm" });
    this.MensajeConfirmar = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "MensajeConfirmar" });
    this.AceptaPublicarRespuesta = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "AceptaPublicarRespuesta" });
    this.AceptaTratamientoDatos = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "AceptaTratamientoDatos" });
    this.AceptaTerminos = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "AceptaTerminos" });
    this.UserData = StaticData.ExternalPqrContact != undefined ? JSON.parse(StaticData.ExternalPqrContact) : StaticData.ExternalPqrContact;

    if (this.UserData != null && this.UserData != undefined) 
    {
    /*if (this.modelo.modelo.EsAnonima) {
      //debugger;
      //this.CheckSolicitudAnonima.Valor = false;
      //this.AccordionGeneral.Hidden = false;
      this.AccordionPoliticas.Hidden = false;
      this.modelo.modelo.EsAnonima = false;
      this.SolicitudAnonimaHeader.Hidden = true;
      this.MensajeSolicitudAnonima.Hidden = true;
      this.Pagina.Titulo = 'Formular una solicitud';
    }*/
      this.MensajeContacto.Hidden = false;
      this.MensajeContactoAnonimo.Hidden = true;
      this.IdTipoRespuestaAutenticado.Hidden = false;
      this.IdTipoRespuesta.Hidden = true;
      this.modelo.modeloVirtual.IdTipoRespuestaAutenticado = 36;
      this.modelo.modelo.IdTipoRespuesta = 36;

      if(this.UserData.IdTipoContacto == 10)
      {
        this.PrimerNombre.Hidden = true;
        this.SegundoNombre.Hidden = true;
        this.PrimerApellido.Hidden = true;
        this.SegundoApellido.Hidden = true;
        this.Genero.Hidden = true;
        this.RazonSocial.Hidden = false;
        this.Cargo.Hidden = false;
      }
      else
      {
        this.PrimerNombre.Hidden = false;
        this.SegundoNombre.Hidden = false;
        this.PrimerApellido.Hidden = false;
        this.SegundoApellido.Hidden = false;
        this.Genero.Hidden = false;
        this.RazonSocial.Hidden = true;
        this.Cargo.Hidden = true;
      }
      this.SetDatosAcceso(this.UserData);
      this.SetCascading();
    }
    else 
    {
      if(StaticData.ExternalPqrAnonimo)
      {

        const context = this;
              const action = {
                ControlDetails: {
                  MappingData: [],
                  MappingFilter: []
                },
                ControlType: "Action",
                ControlsForHidden: [],
                //ControlsToUpdate: ["IdGenero", "PrimerNombre", "PrimerApellido", "RazonSocial", "Cargo", "IdDatoBasico", "TipoIdentificacion", "Identificacion", "IdPais", "IdDepartamento", "IdCiudad", "Direccion", "Celular", "Correo", "CorreoConfirm", "AceptaTratamientoDatos", "AceptaTerminos"],
                ControlsToUpdate: ["IdGenero", "PrimerNombre", "PrimerApellido", "RazonSocial", "Cargo", "IdTipoContacto", "IdTipoRespuestaAutenticado", "IdTipoIdentificacion", "Identificacion", "IdPais", "IdDepartamento", "IdCiudad", "Direccion", "Celular"],
                Guid: Guid.create().toString(),
                IsPost: false,
                IsParentModel: false,
                MappingValues: [],
                MappingComponents: [],
                Property: "required",
                PropertyValue: "false",
                ResultType: "Url",
                SendQueryString: false,
                TimerAction: 0,
                Type: ControlActions[ControlActions.SetControlProperty]
              };
              this.helperActions.SetControlsValue(action, context);
  
              const actionRS = {
                ControlDetails: {
                  MappingData: [],
                  MappingFilter: []
                },
                ControlType: "Action",
                ControlsForHidden: [],
                ControlsToUpdate: ["AceptaPublicarRespuesta"],
                Guid: Guid.create().toString(),
                IsPost: false,
                IsParentModel: false,
                MappingValues: [],
                MappingComponents: [],
                Property: "required",
                PropertyValue: "true",
                ResultType: "Url",
                SendQueryString: false,
                TimerAction: 0,
                Type: ControlActions[ControlActions.SetControlProperty]
              };
              this.helperActions.SetControlsValue(actionRS, context);
  
              //this.LimpiarDatosContacto();
              this.NoDatos.Hidden = false;
              this.AccordionGeneral.Hidden = false;
              this.MensajeContactoAnonimo.Hidden = false;
              this.MensajeContacto.Hidden = true;
              this.Genero.Hidden = true;
              this.PrimerNombre.Hidden = true;
              this.SegundoNombre.Hidden = true;
              this.PrimerApellido.Hidden = true;
              this.SegundoApellido.Hidden = true;
              this.RazonSocial.Hidden = true;
              this.Cargo.Hidden = true;
              this.SolicitudAnonimaHeader.Hidden = false;
              this.MensajeSolicitudAnonima.Hidden = false;
              this.Pagina.Titulo = 'Formular una solicitud anónima';
              //this.AccordionPoliticas.Hidden = true;
              this.TextoNotificacionElectronica.Hidden = false;
              this.TextoTratamientoDatos.Hidden = false;
              this.TipoContacto.Hidden = true;
              this.IdTipoRespuestaAutenticado.Hidden = true;
              this.IdTipoRespuesta.Hidden = false;
              this.TipoIdentificacion.Hidden = true;
              this.NumeroIdentificacion.Hidden = true;
              this.Pais.Hidden = true;
              this.Departamento.Hidden = true;
              this.Ciudad.Hidden = true;
              this.Indicativo.Hidden = true;
              this.Direccion.Hidden = true;
              this.CodigoPostal.Hidden = true;
              this.Celular.Hidden = true;
              this.Telefono.Hidden = true;
              this.Extension.Hidden = true;
              this.Correo.Hidden = false;
              this.CorreoConfirm.Hidden = false;
              this.modelo.modelo.EsAnonima = true;
              this.AceptaPublicarRespuesta.Hidden = false;
              this.AceptaTratamientoDatos.Hidden = false;
              this.modelo.modelo.NoDatosPersonales = false;
              this.AceptaTerminos.Hidden = false;
              this.modelo.modelo.IdTipoSolicitud = '';
              this.modelo.modelo.IdTemaSolicitud = '';
              this.Anonimo = true;
              this.modelo.modelo.IdTipoRespuesta = 36;
              this.SetModelToControls();
      }

      /*
      //debugger;
      this.CheckSolicitudAnonima.Valor = true;
      this.AccordionGeneral.Hidden = true;
      //this.AccordionPoliticas.Hidden = true;
      this.modelo.modelo.EsAnonima = true;
      this.SolicitudAnonimaHeader.Hidden = false;
      this.MensajeSolicitudAnonima.Hidden = false;
      this.Pagina.Titulo = 'Formular una solicitud anónima';
      this.Anonimo = true;
      this.SetModelToControls();*/
    }
  }

  public LoginPqr() {

    let modeloTemp = this.utility.Clone(this.model);
    modeloTemp.UData = btoa(this.model.UData);
    modeloTemp.AppKey = StaticData.AppKey;
    //modeloTemp.CData = btoa(this.model.CData);
    let obj = this.utility.GetApiModel('LoginPQR', '', CrudActions.None, null, modeloTemp);
    this.baseService.LoginPQR(obj, null,
      { componentName: 'ModalLoginComponent', method: 'LoginPQR', processMessage: 'Procesando credenciales....' },
      'AuthenticationBase', false, true).then(data => {

        //debugger;
        if (!data.Data || data.Data.Table === undefined || data.Data.Table[0] === undefined) {
          this.utility.VerModalWarning(
            { titulo: 'Mensaje Alerta', descripcion: 'El usuario no es valido en el sistema.....', verOk: true, verCancelar: false, ok: 'ACEPTAR', cancelar: 'NO' }).then(data => { });

          //throw 'El usuario no es valido en el sistema';
          return;
        }
        StaticData.Usuario = data.Data.Table[0];
        StaticData.Usuario.Token = data.Data.Token;

        if (StaticData.Usuario.Activo == false) {
          StaticData.Usuario = null;
          this.utility.VerModalWarning(
            { titulo: 'Mensaje Alerta', descripcion: 'El usuario no se encuentra activo.....', verOk: true, verCancelar: false, ok: 'ACEPTAR', cancelar: 'NO' }).then(data => { });


          //throw 'El usuario no se encuentra activo';
          return;
        }
        if (!data.Data.Token) {
          StaticData.Usuario = null;


          this.utility.VerModalWarning(
            { titulo: 'Mensaje Alerta', descripcion: 'Token Invalido....', verOk: true, verCancelar: false, ok: 'ACEPTAR', cancelar: 'NO' }).then(data => { });

          //throw 'El usuario no se encuentra activo';
          return;
        }

        ////debugger;
        StaticData.Usuario.MenusUsuario = data.Data.Table1;
        StaticData.Usuario.PaginasUsuario = data.Data.Table2;
        StaticData.Usuario.Paginas = data.Data.Table3;
        // CM
        //StaticData.Usuario.ReportesUsuario = data.Data.Table4;


        StaticData.GeneralConfig = data.Data.GeneralConfig;


        if (!StaticData.GeneralConfig.ConfigUI.TiempoMensajesAdicionalModalEnNotifi)
          StaticData.GeneralConfig.ConfigUI.TiempoMensajesAdicionalModalEnNotifi = 500;

        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionError)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionError = 500;
        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionAlerta)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionAlerta = 500;
        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionOk)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionOk = 500;
        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionInfo)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionInfo = 500;

        if (data.Data.ToolBox) {
          StaticData.ToolBox = JSON.parse(data.Data.ToolBox.StringValue);
          StaticData.ToolBox.Id = data.Data.ToolBox.Id;
          StaticData.ToolBox.TipoDato = data.Data.ToolBox.TipoDato;
          StaticData.ToolBox.Name = data.Data.ToolBox.Name;
        }
        StaticData.WorkFlowTaskConfig = data.Data.WorkFlowTaskConfig;
        /* 
                $.each(StaticData.Usuario.PaginasUsuario, function (key, pagina) {
        
                  // > [8, 10]
                  //var camposPaginas = Enumerable.From(data.Data.Table5).Where(function (x) { return x.IdPagina == pagina.IdPagina }).ToArray();
        
                  var paginaConfig = {
                    IdPagina: pagina.IdPagina,
                    Nombre: pagina.Pagina, Config: {}
                  };
                  if(pagina.Configuracion){
        
                  }
        
                  StaticData.ConfigPaginas.push(paginaConfig);
                }); */



        StaticData.Usuario.Rules = data.Data.Rules;

        //CM 
        /*
        $.each(StaticData.Usuario.ReportesUsuario, function (key, reporte) {
   
          if (reporte.ConfiguracionFiltro && reporte.ConfiguracionFiltro !== null) {
            reporte.ConfigFilter = JSON.parse(reporte.ConfiguracionFiltro);
            let shapes = new List<any>(reporte.ConfigFilter.Shapes);
            reporte.ConfigFilter.Shapes = shapes.Where(x => x.Active == true).ToArray();
            // reporte.ConfigFilter.Shapes = Enumerable.From(reporte.ConfigFilter.Shapes).Where(function (x) { return x.Active == true }).ToArray();
          }
        });
        */





        // let BotonesComoMenu = StaticData.ParametrosGenerales.Where(x=>{return x.Nombre=='BotonesComoMenu' }).FirstOrDefault();
        // StaticData.BotonesComoMenu =(BotonesComoMenu)?BotonesComoMenu.ValorFalsoVerdadero:false;

        let estilosGenerales = (data.Data.Table4 && data.Data.Table4.length > 0) ? new List<any>(data.Data.Table4) : new List<any>([]);
        let estilosPorRole = (data.Data.Table5 && data.Data.Table5.length > 0) ? new List<any>(data.Data.Table5) : new List<any>([]);

        StaticData.ParametrosGenerales = (data.Data.Table6) ? new List<any>(data.Data.Table6) : new List<any>([]);
        /*  let ConfigGeneral = StaticData.ParametrosGenerales.FirstOrDefault(x => { return x.Nombre == 'ConfigGeneral' });
         if (ConfigGeneral) {
           StaticData.ConfigGeneral = JSON.parse(ConfigGeneral);
          
         } */
        ////debugger;
        StaticData.RolesUsuariosGrupos = new List<any>(data.Data.Table7);
        StaticData.Carpetas = new List<any>(data.Data.Table8);
        StaticData.AreasEmpresa = new List<any>(data.Data.Table9);
        StaticData.Series = new List<any>(data.Data.Table10);
        StaticData.SubSeries = new List<any>(data.Data.Table11);

        let BotonesComoMenu: string = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'BotonesComoMenu', '');
        StaticData.BotonesComoMenu = false;

        if (BotonesComoMenu &&
          (BotonesComoMenu.toLowerCase() == 'si' ||
            BotonesComoMenu.toLowerCase() == 'ok' ||
            BotonesComoMenu.toLowerCase() == 'yes' ||
            BotonesComoMenu.toLowerCase() == 'true' ||
            BotonesComoMenu.toLowerCase() == '1'))
          StaticData.BotonesComoMenu = true;


        let Tema = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'Tema', '');

        let ColorMenu = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorMenu', 'blue');
        let ColorTitulos = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorTitulos', 'blue');
        let ColorBotonGuardar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonGuardar', 'blue');

        let ColorBotonLimpiar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonLimpiar', 'blue');
        let ColorBotonFiltro = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonFiltro', 'blue');
        let ColorBotonImportar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonImportar', 'blue');
        let ColorBotonExportarExcel = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonExportarExcel', 'blue');
        let ColorBotonExportarCsv = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonExportarCsv', 'blue');
        let ColorBotonRedireccion = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonRedireccion', 'blue');
        let ColorBotonBuscar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonBuscar', 'blue');

        let ClassMenu = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassMenu', '');
        //let ClassTitulos =this.GetDatosEstilos(estilosPorRole,estilosGenerales,'ClassTitulos','blue');
        let ClassBotonGuardar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonGuardar', 'btn btn-outline-success');
        let ClassBotonLimpiar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonLimpiar', 'btn btn-outline-info');
        let ClassBotonFiltro = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonFiltro', 'btn btn-outline-info');
        let ClassBotonImportar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonImportar', 'btn btn-outline-info');
        let ClassBotonExportarExcel = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonExportarExcel', 'btn btn-outline-info');
        let ClassBotonExportarCsv = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonExportarCsv', 'btn btn-outline-info');
        let ClassBotonRedireccion = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonRedireccion', 'btn btn-outline-info');
        let ClassBotonBuscar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonBuscar', 'btn btn-outline-info');
        let ClassTitulo = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassTitulo', '');


        let ClassContenedorGeneral = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedorGeneral', 'container');
        let ClassContenedor = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedor', 'container card');
        let ClassHeader = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassHeader', 'card-header info-color white-text text-center py-4');
        let ClassContenedorForm = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedorForm', 'card-body px-lg-5 pt-0');

        let ClassContenedorControlesAdd = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedorControlesAdd', '');

        let ClassControles = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassControles', 'md-form');

        let ClassBotonOpcion = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonOpcion', 'btn btn-info btn dropdown-toggle');

        let _EstiloTitulo = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloTitulo', 'blue');
        let EstiloTitulo = this.SetStyle(_EstiloTitulo, ColorTitulos, { color: ColorTitulos });
        let _EstiloBotonGuardar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonGuardar', '');
        let EstiloBotonGuardar = this.SetStyle(_EstiloBotonGuardar, ColorBotonGuardar, {
          'background-color': ColorBotonGuardar,
          'border-color': ColorBotonGuardar,
          'cursor': 'pointer'
        });
        let _EstiloBotonLimpiar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonLimpiar', '');
        let EstiloBotonLimpiar = this.SetStyle(_EstiloBotonLimpiar, ColorBotonLimpiar, {
          'background-color': ColorBotonLimpiar,
          'border-color': ColorBotonLimpiar,
          'cursor': 'pointer'
        });

        let _EstiloBotonFiltro = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonFiltro', '');
        let EstiloBotonFiltro = this.SetStyle(_EstiloBotonFiltro, ColorBotonFiltro, {
          'background-color': ColorBotonFiltro,
          'border-color': ColorBotonFiltro,
          'cursor': 'pointer'
        });

        let _EstiloBotonImportar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonImportar', '');
        let EstiloBotonImportar = this.SetStyle(_EstiloBotonImportar, ColorBotonImportar, {
          'background-color': ColorBotonImportar,
          'border-color': ColorBotonImportar,
          'cursor': 'pointer'
        });
        let _EstiloBotonExportarExcel = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonExportarExcel', '');
        let EstiloBotonExportarExcel = this.SetStyle(_EstiloBotonExportarExcel, ColorBotonExportarExcel, {
          'background-color': ColorBotonExportarExcel,
          'border-color': ColorBotonExportarExcel,
          'cursor': 'pointer'
        });
        let _EstiloBotonExportarCsv = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonExportarCsv', '');
        let EstiloBotonExportarCsv = this.SetStyle(_EstiloBotonExportarCsv, ColorBotonExportarCsv, {
          'background-color': ColorBotonExportarCsv,
          'border-color': ColorBotonExportarCsv,
          'cursor': 'pointer'
        });

        let _EstiloBotonRedireccion = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonRedireccion', '');
        let EstiloBotonRedireccion = this.SetStyle(_EstiloBotonRedireccion, ColorBotonRedireccion, {
          'background-color': ColorBotonRedireccion,
          'border-color': ColorBotonRedireccion,
          'cursor': 'pointer'
        });

        let _EstiloBotonBuscar = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonBuscar', '');
        let EstiloBotonBuscar = this.SetStyle(_EstiloBotonBuscar, ColorBotonBuscar, {
          'background-color': ColorBotonBuscar,
          'border-color': ColorBotonBuscar,
          'cursor': 'pointer'
        });



        let _EstiloContenedorGeneral = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedorGeneral', '');
        let EstiloContenedorGeneral = this.SetStyle(_EstiloContenedorGeneral, null, null);

        let _EstiloContenedor = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedor', '');
        let EstiloContenedor = this.SetStyle(_EstiloContenedor, null, null);
        let _EstiloHeader = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloHeader', '');
        let EstiloHeader = this.SetStyle(_EstiloHeader, null, null);
        let _EstiloContenedorForm = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedorForm', '');
        let EstiloContenedorForm = this.SetStyle(_EstiloContenedorForm, null, null);


        let _EstiloContenedorControlesAdd = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedorControlesAdd', '');
        let EstiloContenedorControlesAdd = this.SetStyle(_EstiloContenedorControlesAdd, null, null);



        let ClassNodos = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodos', '');//'container alert alert-primary'
        let ClassNodosNuevos = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosNuevos', '');
        let ClassNodosEliminados = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosEliminados', '');
        let ClassNodosModificados = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosModificados', '');
        let ClassNodosCambioPadre = this.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosCambioPadre', '');


        StaticData.Estilos = {
          EstiloBotonGuardar: EstiloBotonGuardar,
          EstiloBotonLimpiar: EstiloBotonLimpiar,
          EstiloBotonFiltro: EstiloBotonFiltro,
          EstiloBotonImportar: EstiloBotonImportar,
          EstiloBotonExportarExcel: EstiloBotonExportarExcel,
          EstiloBotonExportarCsv: EstiloBotonExportarCsv,
          ClassBotonGuardar: ClassBotonGuardar,
          ClassBotonLimpiar: ClassBotonLimpiar,
          ClassBotonFiltro: ClassBotonFiltro,
          ClassBotonImportar: ClassBotonImportar,

          ClassBotonExportarExcel: ClassBotonExportarExcel,
          ClassBotonExportarCsv: ClassBotonExportarCsv,
          ClassControles: ClassControles,
          ClassBotonOpcion: ClassBotonOpcion,
          EstiloTitulo: EstiloTitulo,
          ClassTitulo: ClassTitulo,
          EstiloContenedor: EstiloContenedor,
          ClassContenedor: ClassContenedor,

          EstiloHeader: EstiloHeader,
          ClassHeader: ClassHeader,
          EstiloContenedorForm: EstiloContenedorForm,
          ClassContenedorForm: ClassContenedorForm,
          EstiloContenedorGeneral: EstiloContenedorGeneral,
          ClassContenedorGeneral: ClassContenedorGeneral,
          EstiloContenedorControlesAdd: EstiloContenedorControlesAdd,
          ClassContenedorControlesAdd: ClassContenedorControlesAdd,
          Tema: Tema,
          EstiloBotonRedireccion: EstiloBotonRedireccion,
          ClassBotonRedireccion: ClassBotonRedireccion,
          EstiloBotonBuscar: EstiloBotonBuscar,
          ClassBotonBuscar: ClassBotonBuscar,
          ClassNodos: ClassNodos,
          ClassNodosNuevos: ClassNodosNuevos,
          ClassNodosEliminados: ClassNodosEliminados,
          ClassNodosModificados: ClassNodosModificados,
          ClassNodosCambioPadre: ClassNodosCambioPadre,
          MenuSuperior: {
            'border-bottom': ColorMenu + ' 2px solid'

          },
          Linea: {
            height: '50px', 'border-bottom': ColorMenu + ' 2px solid'

          },



        };

        //debugger;
        this.Logged = true;
        super.ngOnInit();

        //this.endEmitter.emit(true);

      }).catch(error => {
        console.log(error);
        this.SetProcesando(false);
        //this.endEmitter.emit(false);

        //this.comunicationService.raiseLoginErrorEvent(error);
      });


  }

  public GetDatosEstilos(estilosPorRole: List<any>, estilosGenerales: List<any>, nombreKey: any, valorPorDefecto: any): any {
    let obj = estilosPorRole.FirstOrDefault(x => x.Nombre == nombreKey);
    if (!obj)
      obj = estilosGenerales.FirstOrDefault(x => x.Nombre == nombreKey);
    if (!obj)
      return valorPorDefecto;
    else
      return obj.Valor;
  }

  public SetStyle(estilos: any, objetoColor: any, valorPorDefecto: any): any {
    let obj = (valorPorDefecto) ? valorPorDefecto : {};
    if (estilos && estilos.split(';').length > 1 && estilos.split(':').length > 1) {
      obj = { color: null };
      if (objetoColor)
        obj.color = objetoColor;
      $.each(estilos.split(';'), function (key, val) {

        obj[val.split(':')[0]] = val.split(':')[1].trim();
      });
    }
    return obj;
  }

  public SetCascading() {

    let arrived = 0;

    this.configs.ConfigIdPais.onLoadedEmitter = new EventEmitter<any>();
    this.configs.ConfigIdPais.onLoadedEmitter.subscribe(data => {
      //debugger;
      if (this.UserData != null && this.UserData != undefined) {
        this.modelo.modelo.IdPais = parseInt(this.UserData.IdPais);
        this.modelo.modeloCascada.IdPais = parseInt(this.UserData.IdPais);
        this.modelo.modelo.IdDepartamento = parseInt(this.UserData.IdDepartamento);
        this.modelo.modeloCascada.IdDepartamento = parseInt(this.UserData.IdDepartamento);
        this.modelo.modelo.IdCiudad = parseInt(this.UserData.IdCiudad);
        this.modelo.modeloCascada.IdCiudad = parseInt(this.UserData.IdCiudad);
        this.SetModelToControls();
        super.EditCascading();
      }
    })

  }

  public OnActionEventHandler(event) {
    //debugger;
    switch (event.ControlType) {
      case 'Button': {
        switch (event.Name) {
          case 'ConsultaPQRs': {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('ExternalPQRs', 'ConsultaExternalPQR');
            window.scrollTo(0, 0);
            break
          };
          case 'ValidarDocumento':
            {
              var CurrentUrl = window.location.href;
              window.location.href = CurrentUrl.replace('ExternalPQRs', 'ValidarDocumentoExternalPqrs');
              window.scrollTo(0, 0);
              break;
            };
          case 'GuiaUso': {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('ExternalPQRs', 'GuiaUsoExternalPqrs');
            window.scrollTo(0, 0);
            break;
          };
        }
        break
      };

    }
    super.OnActionEventHandler(event);
  }

  public resolved(captchaResponse: string) {
    //debugger;
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  public SetDatosAcceso(data) {
    //debugger;
    this.modelo.modelo.IdContacto = data.IdContacto;
    this.modelo.modelo.TipoIdentificacion = data.TipoIdentificacion;
    this.modelo.modelo.IdTipoContacto = data.IdTipoContacto;
    this.modelo.modelo.IdTipoIdentificacion = data.IdTipoIdentificacion;
    this.modelo.modelo.Identificacion = data.Identificacion;
    this.modelo.modelo.RazonSocial = data.RazonSocial;
    this.modelo.modelo.Cargo = data.Cargo;
    this.modelo.modelo.PrimerNombre = data.PrimerNombre;
    this.modelo.modelo.SegundoNombre = data.SegundoNombre;
    this.modelo.modelo.PrimerApellido = data.PrimerApellido;
    this.modelo.modelo.SegundoApellido = data.SegundoApellido;
    this.modelo.modelo.IdGenero = data.IdGenero;
    this.modelo.modelo.CodigoPostal = data.CodigoPostal;
    this.modelo.modelo.Celular = data.Celular;
    this.modelo.modelo.Telefono = data.Telefono;
    this.modelo.modelo.Ext = data.Ext;
    this.modelo.modelo.IdPais = parseInt(data.IdPais);
    this.modelo.modelo.IdDepartamento = parseInt(data.IdDepartamento);
    this.modelo.modelo.IdCiudad = parseInt(data.IdCiudad);
    this.modelo.modelo.Direccion = data.Direccion;
    this.modelo.modelo.Correo = data.Correo;
    this.modelo.modeloCascada.IdPais = parseInt(data.IdPais);
    this.modelo.modeloCascada.IdDepartamento = parseInt(data.IdDepartamento);
    this.modelo.modeloCascada.IdCiudad = parseInt(data.IdCiudad);

    this.DatosUsuario = data.NombreCompleto + ', ID ' + data.Identificacion;
    let FechaIngreso = new Date();
    this.DatosIngreso = 'Fecha de ingreso a las ' + (FechaIngreso.getHours().toString().length == 1 ? '0' + FechaIngreso.getHours() : FechaIngreso.getHours()) + ":" + (FechaIngreso.getMinutes().toString().length == 1 ? '0' + FechaIngreso.getMinutes() : FechaIngreso.getMinutes()) + ', ' + FechaIngreso.getDate() + ' de ' + this.Meses[(FechaIngreso.getMonth())] + ', ' + FechaIngreso.getFullYear();

    this.SetModelToControls();
  }

  public AddComponentInstanceHandler(event) {
    //debugger;
    if (event instanceof DataTableComponent) {
      //debugger;
      if (event.name == 'GrillaReasignarUsuario' || event.name == 'GrillaAsignarExpediente') {
        event.parentContext = this;
      }
      this.componentsContainer.Tables.push(event);
    }
    else {
      super.AddComponentInstanceHandler(event)
    }
  }

  public LimpiarConfirm() {
    if (this.Pagina.VerComfirmarLimpiar != true) {

      this.ExcecuteFuntion(ControllerMethods.Clear, false);
      this.modelo.modeloCascada = {};
      this.Limpiar();

      this.ExcecuteFuntion(ControllerMethods.Clear, true);
      this.SetDatosAcceso(this.UserData);
    }
    else {
      const that = this;
      this.utility.VerModalConfirmacionLimpiar().then(modelo => {
        if (modelo.dialogResult == true) {
          this.ExcecuteFuntion(ControllerMethods.Clear, false);
          this.modelo.modeloCascada = {};
          this.Limpiar();

          this.ExcecuteFuntion(ControllerMethods.Clear, true);
          this.SetDatosAcceso(this.UserData);
        }
      });
    }

  }


  GetConfigPermisos() {
    let permissionsConfig: any = {
      TipoObjetoParaPermiso: TipoObjetoParaPermisos.Expediente,
      Pagina: this.Pagina, clear: true, CreatedRowConfig: {}
    };
  }

  ConvertAnexos() {
    //debugger;
    if (this.modelo.modeloVirtual.GrillaAnexos)
      this.modelo.modelo.Anexos = JSON.stringify(this.modelo.modeloVirtual.GrillaAnexos);
  }

  public GuardarForm(form: FormGroup, configButtons?: any) {
    //debugger;
    if (this.modelo.modelo.EsAnonima == '' || this.modelo.modelo.EsAnonima == undefined) {
      this.modelo.modelo.EsAnonima = false;
    }

    if (!this.modelo.modelo.NoDatosPersonales) {
      if (!this.modelo.modelo.EsAnonima || (this.modelo.modelo.EsAnonima && this.modelo.modelo.IdTipoRespuesta != 34)) {
        if (this.modelo.modelo.Correo.toLowerCase() != this.modelo.modelo.CorreoConfirm.toLowerCase()) {
          this.utility.VerModalError("Los correos Ingresados no coinciden, por favor corríjalos e Inténtelo nuevamente");
          this.SetProcesando(false);
        }
        else {
          super.GuardarForm(form, configButtons);
        }
      }
      else {
        super.GuardarForm(form, configButtons);
      }

    }
    else {
      super.GuardarForm(form, configButtons);
    }

  }

  _Guardar(form: FormGroup, configButtons?: any) {
    //debugger;
    //if (!this.modelo.modelo.EsAnonima) {
      if (this.UserData != null && this.UserData != undefined) 
      {
        this.modelo.modelo.IdTipoRespuesta = this.modelo.modeloVirtual.IdTipoRespuestaAutenticado;
      }
        
    this.modelo.modelo.DataAdd = {
      NombresApellidos: (this.modelo.modelo.IdTipoIdentif == 16 || this.modelo.modelo.IdTipoIdentif == 60) ? this.modelo.modelo.RazonSocial : this.modelo.modelo.PrimerNombre + ' ' + (this.modelo.modelo.SegundoNombre != null && this.modelo.modelo.SegundoNombre != undefined ? this.modelo.modelo.SegundoNombre + ' ' : '') + this.modelo.modelo.PrimerApellido + ' ' + (this.modelo.modelo.SegundoApellido != null && this.modelo.modelo.SegundoApellido != undefined ? this.modelo.modelo.SegundoApellido : ''),
      CorreoContacto: this.modelo.modelo.Correo,
      //Empresa: this.UserData.Empresa,
      Empresa: 'Prueba',
      Contacto: 1,
      Celular: this.modelo.modelo.Celular,
      Telefono: this.modelo.modelo.Telefono,
      Ext: this.modelo.modelo.Ext,
      Ciudad: this.modelo.modeloCascada.IdCiudad,
      Direccion: this.modelo.modelo.Direccion,
      CodigoPostal: this.modelo.modelo.CodigoPostal,
      Correo: this.modelo.modelo.Correo,
      IdTipoContacto: this.modelo.modelo.IdTipoContacto,
      IdTipoIdentificacion: this.modelo.modelo.IdTipoIdentificacion,
      Identificacion: this.modelo.modelo.Identificacion,
      IdGenero: this.modelo.modelo.IdGenero,
      PrimerNombre: this.modelo.modelo.PrimerNombre,
      SegundoNombre: this.modelo.modelo.SegundoNombre,
      PrimerApellido: this.modelo.modelo.PrimerApellido,
      SegundoApellido: this.modelo.modelo.SegundoApellido,
      RazonSocial: this.modelo.modelo.RazonSocial,
      Cargo: this.modelo.modelo.Cargo,
      GuidPlantillaPqrs: this.modelo.modelo.GuidPlantillaPqrs,
      GuidPlantillaPqrsAnonima: this.modelo.modelo.GuidPlantillaPqrsAnonima,
      GuidPlantillaPqrsAnonimaDigital: this.modelo.modelo.GuidPlantillaPqrsAnonimaDigital
    };
    /*}
    else{
      this.modelo.modelo.DataAdd = {
        NombresApellidos: (this.modelo.modelo.TipoIdentificacion == 16 || this.modelo.modelo.TipoIdentificacion == 109) ? this.modelo.modelo.RazonSocial : this.modelo.modelo.PrimerNombre + ' ' + (this.modelo.modelo.SegundoNombre != null && this.modelo.modelo.SegundoNombre != undefined ? this.modelo.modelo.SegundoNombre + ' ' : '') + this.modelo.modelo.PrimerApellido + ' ' + (this.modelo.modelo.SegundoApellido != null && this.modelo.modelo.SegundoApellido != undefined ? this.modelo.modelo.SegundoApellido : ''),
        CorreoContacto: this.modelo.modelo.Correo,
        //Empresa: this.UserData.Empresa,
        Empresa: 'Prueba',
        Contacto: 1,
        Celular: this.modelo.modelo.Celular,
        Telefono: this.modelo.modelo.Telefono,
        Ext: this.modelo.modelo.Ext,
        Ciudad: this.modelo.modeloCascada.IdCiudad,
        Direccion: this.modelo.modelo.Direccion,
        Correo: this.modelo.modelo.Correo,
        IdTipoContacto: this.modelo.modelo.IdTipoContacto,
        IdTipoIdentificacion: this.modelo.modeloCascada.TipoIdentificacion,
        Identificacion: this.modelo.modelo.Identificacion,
        PrimerNombre: this.modelo.modelo.PrimerNombre,
        SegundoNombre: this.modelo.modelo.SegundoNombre,
        PrimerApellido: this.modelo.modelo.PrimerApellido,
        SegundoApellido: this.modelo.modelo.SegundoApellido,
        RazonSocial: this.modelo.modelo.RazonSocial,
        Cargo: this.modelo.modelo.Cargo,
        GuidPlantillaPqrs: this.modelo.modelo.GuidPlantillaPqrs,
        GuidPlantillaPqrsAnonima: this.modelo.modelo.GuidPlantillaPqrsAnonima
      };
    }*/
    this.cnfgButtons = configButtons;
    this.ConvertAnexos();
    let obj: any = null;
    try {
      if (this.Pagina.Valida != true || this.Pagina.Guardar != true)
        return;
      if (form.invalid)
        return;


      let _isEdit = this.IsEdit;
      // const that = this;
      let processMessage = (this.modelo.modelo.PkValue == '0' || this.modelo.modelo.PkValue == '') ? 'Creando Registro de ' + this.Pagina.Titulo : 'Actualizando registro de ' + this.Pagina.Titulo;

      this.ExcecuteFuntion(ControllerMethods.Save, false);


      if (_isEdit)
        this.FireFormEvent({ Name: "OnPreUpdate", modelo: this.modelo });
      else
        this.FireFormEvent({ Name: "OnPreInsert", modelo: this.modelo });

      if (this.modelo.modeloMetadata.Items.Count() > 0) {
        this.modelo.modeloMetadata.IdParentObject = this.modelo.modelo.PkValue;
        this.modelo.modeloMetadata.IdPage = this.Pagina.IdPagina;
        this.modelo.modelo.Metadata = this.utility.Clone(this.modelo.modeloMetadata);
        this.modelo.modelo.Metadata.Items = this.modelo.modelo.Metadata.Items.ToArray();
      }
      //this.modelo.modeloMetadata.Id = this.modelo.modelo.PkValue;
      // this.modelo.modeloMetadata.IdPage = this.Pagina.IdPagina;
      // this.modelo.modelo.Metadata = this.modelo.modeloMetadata;

      obj = this.utility.GetApiModel('Guardar', this.componentName, null, null, this.modelo.modelo);

      let isGeneralSave = true;
      //this.CorreoEmail = this.modelo.modelo.Correo;

      if (this.componentsContainer.FileBox && this.componentsContainer.FileBox.isSelectedFiles()) {

        isGeneralSave = false;
        let externalFiles: any;
        if (this.componentsContainer.FileBoxWorkFlow != null) {
          externalFiles = this.componentsContainer.FileBoxWorkFlow.GetForExternalFilesModel();
        }
        this.componentsContainer.FileBox.uploadFiles(false, obj, externalFiles);

      }


      // ////////Meter validacion antes de este
      if (isGeneralSave) {
        this.baseService.InsertUpdate(obj, form, {
          componentName: this.componentName + 'Controller',
          method: 'Guardar', processMessage: processMessage
        },
          false, this.componentName, false, true).then(data => {
            //this.modelo.modelo = data.Data != null ? data.Data : this.modelo.modelo;
            //debugger;

            this.FinGuardar(data.Data);


            if (_isEdit)
              this.FireFormEvent({ Name: "OnPostUpdate", modelo: this.modelo, data: data });
            else
              this.FireFormEvent({ Name: "OnPostInsert", modelo: this.modelo, data: data });

          }).catch(error => { this.SetProcesando(false); });
      }



    }
    catch (error) {
      this.utility.logger.LogError(error, obj, { componentName: this.componentName, method: '_Guardar' });
      this.utility.VerModalDanger().then(data => { })
      this.SetProcesando(false);
    }

  }

  public OnSelectedComboBox(item: any, controlName: string, config: any) {
    //debugger;
    if (controlName == 'IdTipoRespuesta' || controlName == 'IdTipoRespuestaAutenticado') {
      if(controlName == 'IdTipoRespuestaAutenticado')
        this.modelo.modelo.IdTipoRespuesta = this.modelo.modeloVirtual.IdTipoRespuestaAutenticado;
      if (this.modelo.modelo.EsAnonima) {
        if (item.Codigo == 'F') {
          const context = this;
          const action = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["IdPais", "IdDepartamento", "IdCiudad", "Direccion"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "true",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(action, context);

          const actionRS = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["Correo", "CorreoConfirm", "AceptaPublicarRespuesta"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "false",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(actionRS, context);

          this.Pais.Hidden = false;
          this.AceptaPublicarRespuesta.Hidden = true;
          this.MensajeConfirmar.Hidden = true;
          this.Departamento.Hidden = false;
          this.Ciudad.Hidden = false;
          this.Direccion.Hidden = false;
          this.CodigoPostal.Hidden = false;
          this.Correo.Hidden = true;
          this.CorreoConfirm.Hidden = true;
          this.modelo.modelo.Correo = null;
          this.modelo.modelo.CorreoConfirm = null;

        }
        else if (item.Codigo == 'D') {
          const context = this;
          const action = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["Correo", "CorreoConfirm", "AceptaPublicarRespuesta"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "true",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(action, context);

          const actionRS = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["IdPais", "IdDepartamento", "IdCiudad", "Direccion", "CodigoPostal"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "false",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(actionRS, context);

          this.AceptaPublicarRespuesta.Hidden = false;
          this.MensajeConfirmar.Hidden = false;
          this.Pais.Hidden = true;
          this.Departamento.Hidden = true;
          this.Ciudad.Hidden = true;
          this.Direccion.Hidden = true;
          this.CodigoPostal.Hidden = true;
          this.Correo.Hidden = false;
          this.CorreoConfirm.Hidden = false;

          this.modelo.modeloCascada.IdPais = null;
          this.modelo.modeloCascada.IdDepartamento = null;
          this.modelo.modeloCascada.IdCiudad = null;
          this.modelo.modelo.Direccion = null;
          this.modelo.modelo.CodigoPostal = null;

        }
        else if (item.Codigo == 'M') {
          const context = this;
          const action = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["IdPais", "IdDepartamento", "IdCiudad", "Direccion", "Correo", "CorreoConfirm", "AceptaPublicarRespuesta"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "true",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(action, context);

          this.AceptaPublicarRespuesta.Hidden = false;
          this.MensajeConfirmar.Hidden = false;
          this.Pais.Hidden = false;
          this.Departamento.Hidden = false;
          this.Ciudad.Hidden = false;
          this.Direccion.Hidden = false;
          this.CodigoPostal.Hidden = false;
          this.Correo.Hidden = false;
          this.CorreoConfirm.Hidden = false;

          this.modelo.modeloCascada.IdPais = null;
          this.modelo.modeloCascada.IdDepartamento = null;
          this.modelo.modeloCascada.IdCiudad = null;
          this.modelo.modelo.Direccion = null;
          this.modelo.modelo.CodigoPostal = null;
          this.modelo.modelo.Correo = null;
          this.modelo.modelo.CorreoConfirm = null;

        }
        this.SetModelToControls();
      }
      else {
        if (item.Codigo == 'F') {
          const context = this;

          const actionRS = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["AceptaPublicarRespuesta"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "false",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(actionRS, context);

          this.AceptaPublicarRespuesta.Hidden = true;

        }
        else if (item.Codigo == 'D') {
          const context = this;
          const action = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["AceptaPublicarRespuesta"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "true",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(action, context);

          this.AceptaPublicarRespuesta.Hidden = false;
        }
        else if (item.Codigo == 'M') {
          const context = this;
          const action = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["AceptaPublicarRespuesta"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "true",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(action, context);

          this.AceptaPublicarRespuesta.Hidden = false;

        }
        this.SetModelToControls();
      }

    }




    if (controlName == 'IdDatoBasico') {
      this.modelo.modelo.IdTipoIdentif = null;
      this.modelo.modeloCascada.TipoIdentificacion = null;
      this.SetModelToControls();
    }

    if (controlName == 'TipoIdentificacion') {
      //debugger;
      this.modelo.modelo.IdTipoIdentif = item.IdDatoBasico;
      if (item.Codigo == 'NIT') {
        const context = this;
        const action = {
          ControlDetails: {
            MappingData: [],
            MappingFilter: []
          },
          ControlType: "Action",
          ControlsForHidden: [],
          ControlsToUpdate: ["PrimerNombre", "PrimerApellido", "IdGenero"],
          Guid: Guid.create().toString(),
          IsPost: false,
          IsParentModel: false,
          MappingValues: [],
          MappingComponents: [],
          Property: "required",
          PropertyValue: "false",
          ResultType: "Url",
          SendQueryString: false,
          TimerAction: 0,
          Type: ControlActions[ControlActions.SetControlProperty]
        };
        this.helperActions.SetControlsValue(action, context);

        const actionRS = {
          ControlDetails: {
            MappingData: [],
            MappingFilter: []
          },
          ControlType: "Action",
          ControlsForHidden: [],
          //ControlsToUpdate: ["RazonSocial", "PrimerNombre", "PrimerApellido"],
          ControlsToUpdate: ["RazonSocial", "Cargo"],
          Guid: Guid.create().toString(),
          IsPost: false,
          IsParentModel: false,
          MappingValues: [],
          MappingComponents: [],
          Property: "required",
          PropertyValue: "true",
          ResultType: "Url",
          SendQueryString: false,
          TimerAction: 0,
          Type: ControlActions[ControlActions.SetControlProperty]
        };
        this.modelo.modelo.IdTipoContacto = 10;
        this.helperActions.SetControlsValue(actionRS, context);

        this.Genero.Hidden = true;
        this.PrimerNombre.Hidden = true;
        this.SegundoNombre.Hidden = true;
        this.PrimerApellido.Hidden = true;
        this.SegundoApellido.Hidden = true;
        this.RazonSocial.Hidden = false;
        this.Cargo.Hidden = false;

      }
      else {
        const context = this;
        const action = {
          ControlDetails: {
            MappingData: [],
            MappingFilter: []
          },
          ControlType: "Action",
          ControlsForHidden: [],
          ControlsToUpdate: ["PrimerNombre", "PrimerApellido", "IdGenero"],
          Guid: Guid.create().toString(),
          IsPost: false,
          IsParentModel: false,
          MappingValues: [],
          MappingComponents: [],
          Property: "required",
          PropertyValue: "true",
          ResultType: "Url",
          SendQueryString: false,
          TimerAction: 0,
          Type: ControlActions[ControlActions.SetControlProperty]
        };
        this.helperActions.SetControlsValue(action, context);

        const actionRS = {
          ControlDetails: {
            MappingData: [],
            MappingFilter: []
          },
          ControlType: "Action",
          ControlsForHidden: [],
          ControlsToUpdate: ["RazonSocial", "Cargo"],
          Guid: Guid.create().toString(),
          IsPost: false,
          IsParentModel: false,
          MappingValues: [],
          MappingComponents: [],
          Property: "required",
          PropertyValue: "false",
          ResultType: "Url",
          SendQueryString: false,
          TimerAction: 0,
          Type: ControlActions[ControlActions.SetControlProperty]
        };
        this.modelo.modelo.IdTipoContacto = 7;
        this.helperActions.SetControlsValue(actionRS, context);

        this.Genero.Hidden = false;
        this.PrimerNombre.Hidden = false;
        this.SegundoNombre.Hidden = false;
        this.PrimerApellido.Hidden = false;
        this.SegundoApellido.Hidden = false;
        this.RazonSocial.Hidden = true;
        this.Cargo.Hidden = true;
        this.SetModelToControls();

      }

      const context = this;
      const actionTI = {
        ControlDetails: {
          MappingData: [],
          MappingFilter: []
        },
        ControlType: "Action",
        ControlsForHidden: [],
        //ControlsToUpdate: ["IdGenero", "PrimerNombre", "PrimerApellido", "RazonSocial", "Cargo", "IdDatoBasico", "TipoIdentificacion", "Identificacion", "IdPais", "IdDepartamento", "IdCiudad", "Direccion", "Celular", "Correo", "CorreoConfirm", "AceptaTratamientoDatos", "AceptaTerminos"],
        ControlsToUpdate: ["Identificacion"],
        Guid: Guid.create().toString(),
        IsPost: false,
        IsParentModel: false,
        MappingValues: [],
        MappingComponents: [],
        Property: "required",
        PropertyValue: item.IdDatoBasico == 60 ? "false" : "true",
        ResultType: "Url",
        SendQueryString: false,
        TimerAction: 0,
        Type: ControlActions[ControlActions.SetControlProperty]
      };
      this.helperActions.SetControlsValue(actionTI, context);


      this.SetModelToControls();
    }
    if (controlName == 'IdTemaSolicitud') {
      ////debugger;
      if (item) {
        /*if (item.Configuracion || item.IdUsuarioResponsable) {
          const configUsuarioResp = JSON.parse(item.Configuracion);
          if(item.Configuracion == null){
            this.modelo.modelo.IdUsuarioResponsable = item.IdUsuarioResponsable;
          }
          else if(item.Configuracion && configUsuarioResp.length == 0){
            this.modelo.modelo.IdUsuarioResponsable = item.IdUsuarioResponsable;

          }else{
          this.modelo.modelo.IdUsuarioResponsable = configUsuarioResp[0].Id;
          }*/
        //debugger;
        if (item.IdUsuarioResponsable) {
          this.modelo.modelo.IdUsuarioResponsable = item.IdUsuarioResponsable;
        } else
          this.utility.VerModalError(
            "La temática seleccionada no posee responsable"
          );
      }
    }
    if (controlName == 'IdPais') {
      //debugger;
      if (this.modelo.modeloCascada.IdPais != 1 && this.modelo.modeloCascada.IdPais !=null){
      this.Departamento.Hidden = true;
      //this.Departamento.Required = false;
      const context = this;
          const action = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["IdDepartamento"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "false",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(action, context);
      if (this.modelo.modeloCascada.IdPais) {
        let obj = this.utility.GetApiModel('ConsultaPaisCiudad', null)
        obj.QueryConfig = {
          Command: 'ConsultaPaisCiudad',
          IsSp: true,
          Entity: {
            IdPais: this.modelo.modeloCascada.IdPais
          }
        };
        let info = {
          componentName: this.componentName, controlName: 'ConsultaPaisCiudad',
          processMessage: 'Cargando Ciudad......'
        };

        this.baseService.Get(obj, null, info, this.componentName, false, false).then(data => {

          //debugger;
          this.modelo.modeloCascada.IdDepartamento = data.Data[0].IdDepartamento;
          super.EditCascading();
          //this.SetModelToControls();
          //super.EditCascading();
        }).catch(err => { this.utility.logger.LogError(err, obj, { componentName: this.componentName, method: 'Consulta' }); });
      }
      else
      {
        this.modelo.modeloVirtual.Indicativo = null;
      }
    }else{
      this.Departamento.Hidden = false;
      //this.Departamento.Required = true;
      const context = this;
          const action = {
            ControlDetails: {
              MappingData: [],
              MappingFilter: []
            },
            ControlType: "Action",
            ControlsForHidden: [],
            ControlsToUpdate: ["IdDepartamento"],
            Guid: Guid.create().toString(),
            IsPost: false,
            IsParentModel: false,
            MappingValues: [],
            MappingComponents: [],
            Property: "required",
            PropertyValue: "true",
            ResultType: "Url",
            SendQueryString: false,
            TimerAction: 0,
            Type: ControlActions[ControlActions.SetControlProperty]
          };
          this.helperActions.SetControlsValue(action, context);
    }
      //Colombia Id = 1
      ////debugger
      if (this.modelo.modeloCascada.IdPais) {
        let obj = this.utility.GetApiModel('ConsultaIndicativo', null)
        obj.QueryConfig = {
          Command: 'ConsultaIndicativo',
          IsSp: true,
          Entity: {
            IdPais: this.modelo.modeloCascada.IdPais
          }
        };
        let info = {
          componentName: this.componentName, controlName: 'ConsultaIndicativo',
          processMessage: 'Cargando ConsultaIndicativo......'
        };

        this.baseService.Get(obj, null, info, this.componentName, false, false).then(data => {

          //debugger
          this.modelo.modeloVirtual.Indicativo = data.Data[0].Indicativo
          this.SetModelToControls();
        }).catch(err => { this.utility.logger.LogError(err, obj, { componentName: this.componentName, method: 'Consulta' }); });
      }
      else {
        this.modelo.modeloVirtual.Indicativo = null;
      }

      const context = this;
      this.helperActions.MultiSetControlsValue(
        [
          {
            ControlsToUpdate: ["CodigoPostal"],
            PropertiesToSet: {
              required: item ? item.IdPais != 1 : false
            },
          },
        ],
        context
      );



      this.modelo.modelo.IdDepartamento = null;
      this.modelo.modeloCascada.IdDepartamento = null;
      this.modelo.modelo.IdCiudad = null;
      this.modelo.modeloCascada.IdCiudad = null;
      this.SetModelToControls();
    }
    if (controlName == 'IdDepartamento') {
      this.modelo.modelo.IdCiudad = null;
      this.modelo.modeloCascada.IdCiudad = null;
      this.SetModelToControls();
    }
    if (controlName == 'IdCiudad') {
      this.modelo.modelo.IdCiudad = this.modelo.modeloCascada.IdCiudad;
      this.SetModelToControls();
    }
    if (controlName == 'IdTipoSolicitud') {
      this.modelo.modelo.IdTemaSolicitud = '';
      /*if(this.modelo.modelo.EsAnonima == '')
      {
        this.modelo.modelo.EsAnonima=false
      }*/
      this.SetModelToControls();
    }


    super.OnSelectedComboBox(item, controlName, config);
  }

  SalidaPqrs($event) {
    //debugger;
    this.LimpiarSesion();
  }

  public LimpiarSesion() {
    //debugger;

    this.DatosUsuario = null;
    this.DatosIngreso = null;
    var CurrentUrl = window.location.href;
    StaticData.ContactAuthenticated = false;
    window.location.href = CurrentUrl.replace('ExternalPQR', 'HomeExternalPQR');
  }

}
